<template>
  <div id="login-form">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="Enter your Email address"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        :rules="passwordRules"
        :append-icon="e1 ? 'visibility_off' : 'visibility'"
        :append-icon-cb="() => { return (e1 = !e1)}"
        :type="e1 ? 'password' : 'text'"
        name="input-10-1"
        label="Enter your password"
        hint="At least 8 characters"
        min="8"
        counter
        required
      ></v-text-field>
      <v-btn :disabled="!valid" @click="submit" color="primary">Submit</v-btn>
      <v-btn @click="clear" dark>Clear</v-btn>
    </v-form>
  </div>
</template>

<script>
import Api from '@/api'
import { mapActions } from 'vuex'

export default {
  name: 'login-form',
  data () {
    return {
      e1: true,
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Password is required'
      ]
    }
  },
  methods: {
    ...mapActions({
      login: 'adminUser/login',
      updateAuthData: 'adminUser/updateAuthData'
    }),
    submit () {
      if (this.$refs.form.validate()) {
        const path = '/admin/login'
        const data = {
          email: this.email,
          password: this.password
        }
        this.$swal({
          title: 'Signing In',
          onOpen: () => {
            // let that = this
            this.$swal.showLoading()
            Api.post(path, data)
              .then(response => {
                if (response.data.status === 0 || response.data.status === 2) {
                  this.login(response.data.current_user)
                    .then(() => {
                      this.updateAuthData(response.data.api_data)
                      this.clear()
                      this.$swal(response.data.message)
                      this.$router.push('/admin')
                    })
                } else {
                  this.$swal(response.data.message)
                }
              })
              .catch(error => {
                this.$swal(error.toString().substring(0, 100))
              })
          },
          allowOutsideClick: () => !this.$swal.isLoading()
        })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/LoginForm.vue